import React, { useRef, useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { Modal, Button, Form } from 'react-bootstrap';
import ButtonSpinner from '../../layout/ButtonSpinner';
import { ICON_SAVE, ICON_CANCEL, ICON_SEARCH, ICON_REMOVE } from '../../extras/icons';
import { v4 as uuidv4 } from 'uuid';
import LawyerSearchForm from '../LawyerSearchForm';
import { WaitingMessage } from '../../extras/toastMessages';
import Swal from 'sweetalert2';
//Función principal
const VictimFormModal = props => {
    //Tomo los props
    const { show, handleClose, victims, setVictims, defensories, selectedVictim, provincias, localidades } = props;
    //Genero los refs
    const refApellido = useRef();
    //Datos iniciales
    const initialData = {
        index: uuidv4(),
        apellido: '',
        nombre: '',
        tipo_documento: '',
        nro_documento: '',
        domicilio: '',
        email: '',
        telefono: '',
        menor: 0,
        querellante: 0,
        defensoria: '',
        particular: []
    }
    useEffect(() => {
        //Me fijo si es edición
        if(selectedVictim && selectedVictim.index){
            setVictim({
                index: selectedVictim.index,
                apellido: selectedVictim.persona.apellido,
                nombre: selectedVictim.persona.nombre,
                tipo_documento: selectedVictim.persona.tipo_documento,
                nro_documento: selectedVictim.persona.nro_documento,
                domicilio: selectedVictim.domicilio,
                email: selectedVictim.email,
                telefono: selectedVictim.telefono,
                menor: selectedVictim.menor,
                querellante: selectedVictim.querellante,
                defensoria: selectedVictim.defensoria ? selectedVictim.defensoria.id : '',
                particular: selectedVictim.particular
            })
        }else{
            setVictim(initialData);
        }
    }, [selectedVictim]);
    //Inicializo el state local
    const [ victim, setVictim ] = useState(initialData);
    const [ loading, setLoading ] = useState(false);
    const [ showLawyer, setShowLawyer ] = useState(false);
    const [ particulars, setParticulars ] = useState([]);
    const [ hide, setHide ] = useState(false);
    //Manejo de cambios
    const handleChange = e => {
        setVictim({
            ...victim,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Muestro espera
        setLoading(true);
        WaitingMessage('Agregando víctima');
        //Tomo datos
        const defensory = defensories.find(d => d.id === parseInt(values.defensoria));
        //Armo el objeto de datos
        let data = {
            index: victim.index,
            persona: {
                apellido: values.apellido,
                nombre: values.nombre,
                tipo_documento: values.tipo_documento,
                nro_documento: String(values.nro_documento).replaceAll('.','').replaceAll('-','').replaceAll('/','').replaceAll(' ', '').trim()
            },
            domicilio: values.domicilio,
            email: values.email,
            telefono: values.telefono,
            menor: values.menor,
            defensoria: defensory ? {
                id: values.defensoria,
                descripcion: defensory.descripcion
            } : null,
            querellante: values.querellante,
            particular: particulars
        }
        //Me fijo si es edicción
        if(selectedVictim){
            //Lo actualizo
            setVictims(victims.map( victim =>
                victim.index === data.index ? victim = data : victim
            ));
        }else{
            //Lo agrego a los acusados
            setVictims([
                ...victims,
                data
            ]);
        }
        //Cierro la ventana
        handleCloseForm();
        //Oculto espera
        Swal.close();
        setLoading(false);
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Limpio los particulares
        setParticulars([]);
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setVictim(initialData);
        //Cierro
        handleClose();
    }
    //Eliminar abogado particular
    const handleRemoveLawyer = selected => {
        //Seteo sin el abogado eliminado
        setParticulars(
            particulars.filter( p => p.index !== selected.index )
        );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        tipo_documento: yup.string().required(),
        nro_documento: yup.number().required(),
        menor: yup.number().required(),
        querellante: yup.number().required(),
        domicilio: yup.string().required(),
        telefono: yup.string().nullable(),
        email: yup.string().email().when('telefono', {
            is: (telefono) => !telefono || telefono.length === 0,
            then: yup.string().email().required(),
            otherwise: yup.string().email().nullable()
        })
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="xl"
        >
            {
                hide ? (
                    <div className="custom-backdrop-modal"></div>
                ) : null
            }
            <Modal.Header closeButton>
                <Modal.Title>
                    Víctima&nbsp;
                    <small><strong>{ selectedVictim ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...victim }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Complete los datos personales de la VÍCTIMA. El <strong>Tipo y Nª de documento</strong> son obligatorios.
                                        <br/>
                                        En relación al nro. de teléfono y el email, sólo es obligatorio uno de los dos campos.
                                    </div>
                                </div>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="apellido"
                                        className="form-control" 
                                        autoFocus 
                                        name="apellido" 
                                        type="text" 
                                        placeholder="Apellido"
                                        value={ values.apellido }
                                        onChange={handleChange}
                                        ref={refApellido}
                                        isInvalid={!!errors.apellido}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        name="nombre" 
                                        type="text" 
                                        placeholder="Nombre"
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nombre}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        as="select"
                                        id="tipo_documento"
                                        className="form-control"  
                                        name="tipo_documento" 
                                        type="text" 
                                        value={ values.tipo_documento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo_documento}
                                        disabled={ loading }
                                    >
                                        <option value="">Tipo documento</option>
                                        <option value="DNI">DNI</option>
                                        <option value="CUIT">CUIT/CUIL</option>
                                        <option value="PASAPORTE">PASAPORTE</option>
                                        <option value="MATRICULA">MATRICULA</option>
                                        <option value="LC">L.C.</option>
                                        <option value="LE">L.E.</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo_documento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        id="nro_documento"
                                        className="form-control" 
                                        name="nro_documento" 
                                        type="text" 
                                        placeholder="Nro. Documento"
                                        value={ values.nro_documento }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nro_documento}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nro_documento }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="domicilio"
                                        className="form-control" 
                                        name="domicilio" 
                                        type="text" 
                                        placeholder="Domicilio"
                                        value={ values.domicilio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.domicilio}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.domicilio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        placeholder="Teléfono"
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        placeholder="Email"
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                    Seleccione si la VÍCTIMA es <strong>MENOR</strong> o no. También debe indicar si es <strong>QUERELLANTE</strong>
                                    </div>
                                </div>
                                <Form.Group className="col-md-2">
                                    <Form.Label>Es menor?</Form.Label>
                                    <Form.Control
                                        as="select"
                                        id="menor"
                                        className="form-control"  
                                        name="menor"  
                                        value={ values.menor }
                                        onChange={handleChange}
                                        isInvalid={!!errors.menor}
                                        disabled={ loading }
                                    >
                                        <option value="0">NO</option>
                                        <option value="1">SI</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.menor }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-2">
                                    <Form.Label>Es querellante?</Form.Label>
                                    <Form.Control
                                        as="select"
                                        id="querellante"
                                        className="form-control"  
                                        name="querellante"  
                                        value={ values.querellante }
                                        onChange={handleChange}
                                        isInvalid={!!errors.querellante}
                                        disabled={ loading }
                                    >
                                        <option value="0">NO</option>
                                        <option value="1">SI</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.querellante }
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <div className="col-12 mt-2">
                                    <div className="alert alert-info">
                                    A cotinuación podrá seleccionar la <strong>DEFENSA TÉCNICA</strong> de la VÍCTIMA. Seleccione si actúa algún equipo operativo del MPD y/o el/los abogado/s correspondientes.
                                    </div>
                                </div>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as="select"
                                        id="defensoria"
                                        className="form-control"  
                                        name="defensoria"  
                                        value={ values.defensoria }
                                        onChange={handleChange}
                                        isInvalid={!!errors.defensoria}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccione el Equipo del MPD</option>
                                        {
                                            defensories ? (
                                                defensories.map(defensory => (
                                                    <option value={defensory.id} key={`afd${defensory.id}`}>
                                                        { defensory.descripcion }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.defensoria }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="col-md-6 form-group">
                                    <Button variant="primary" className="float-right" onClick={() => setShowLawyer(true)}>
                                        <ICON_SEARCH /> BUSCAR ABOGADO PARTICULAR
                                    </Button>

                                    <LawyerSearchForm
                                        show={showLawyer}
                                        handleClose={() => {setShowLawyer(false);setHide(false)}}
                                        particulars={particulars}
                                        setParticulars={setParticulars}
                                        hideModal={setHide}
                                    />
                                </div>
                                <div className="col-12">
                                    {
                                        particulars && particulars.length > 0 ? (
                                            <table className="table table-sm">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th colSpan="4">Abogados particulares</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        particulars.map(particular => (
                                                            <tr key={`vfafp${particular.id}`}>
                                                                <td className="align-middle">
                                                                    { particular.persona.apellido + ', ' + particular.persona.nombre }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    { particular.email }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    { particular.telefono }
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    <Button variant="danger" size="sm" onClick={() => handleRemoveLawyer(particular)}>
                                                                        <ICON_REMOVE />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>{ selectedVictim ? 'ACTUALIZAR' : 'AGREGAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default VictimFormModal;